module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/dom-serializer/~/entities/lib/maps/xml.json
// module id = 547
// module chunks = 0